import * as React from 'react';
import { IListItem } from '../../common/classes/list-item';

export type IProviderListItemProps = IListItem;

export const CareListItem: React.StatelessComponent<IProviderListItemProps> = props => {
    return (
        <li className="adage-search-item">
            <div className="adage-search-item-content">
                <h3 className="adage-search-item-content-heading"><a href={props.pageUrl}>{props.name}</a></h3>

                {props.type ?
                    <div className="adage-search-item-content-subheading">
                        {props.type}
                    </div>
                : null}

                {props.description ?
                    <div className="adage-search-item-content-desc">
                        {props.description}
                    </div>
                : null}
            </div>
        </li>
    )
}